import React, { memo, Fragment, useEffect, useContext, useCallback, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import Scrollbar from 'smooth-scrollbar'
import Logo from './Logo'
import VerticalNav from './VerticalNav'
import SidebarProfileCard from './SidebarProfileCard'
import { useApolloClient } from '@apollo/client'
import { AuthContext } from '../../context/auth-context'
import { ChevronRightIcon, ToogleSidebarIcon, LogoutIcon } from '../../components/icons'

const Sidebar = memo((props) => {
    const client = useApolloClient()
    const navigate = useNavigate()
    const { logout } = useContext(AuthContext)
    const [sideMenuCollapsed, setSideMenuCollapsed] = useState(false)

    const minisidebar = () => {
        document.getElementsByTagName('ASIDE')[0].classList.toggle('sidebar-mini')
        setSideMenuCollapsed((prev) => !prev)
    }

    const onLogout = useCallback(
        async (expired) => {
            const options = expired
                ? {
                      state: {
                          notification: {
                              status: 'warning',
                              message: 'Your session has been expired. Please sign in again.',
                          },
                      },
                  }
                : {}

            try {
                await client.clearStore()
            } catch (error) {}

            navigate('/login', options)
            logout()
        },
        [logout, client, navigate],
    )

    useEffect(() => {
        Scrollbar.init(document.querySelector('#my-scrollbar'))

        window.addEventListener('resize', () => {
            const tabs = document.querySelectorAll('.nav')
            const sidebarResponsive = document.querySelector('[data-sidebar="responsive"]')
            if (window.innerWidth < 1025) {
                Array.from(tabs, (elem) => {
                    if (
                        !elem.classList.contains('flex-column') &&
                        elem.classList.contains('nav-tabs') &&
                        elem.classList.contains('nav-pills')
                    ) {
                        elem.classList.add('flex-column', 'on-resize')
                    }
                    return elem.classList.add('flex-column', 'on-resize')
                })
                if (sidebarResponsive !== null) {
                    if (!sidebarResponsive.classList.contains('sidebar-mini')) {
                        sidebarResponsive.classList.add('sidebar-mini', 'on-resize')
                    }
                }
            } else {
                Array.from(tabs, (elem) => {
                    if (elem.classList.contains('on-resize')) {
                        elem.classList.remove('flex-column', 'on-resize')
                    }
                    return elem.classList.remove('flex-column', 'on-resize')
                })
                if (sidebarResponsive !== null) {
                    if (
                        sidebarResponsive.classList.contains('sidebar-mini') &&
                        sidebarResponsive.classList.contains('on-resize')
                    ) {
                        sidebarResponsive.classList.remove('sidebar-mini', 'on-resize')
                    }
                }
            }
        })
    })

    return (
        <Fragment>
            <aside
                className="sidebar-white left-bordered sidebar sidebar-base tw:!border-r tw:!flex tw:flex-col tw:justify-between"
                data-sidebar="responsive"
            >
                <div className="h-full">
                    <div className="sidebar-header d-flex align-items-center justify-content-start">
                        <Link to="/" className="navbar-brand">
                            <Logo />
                            <h5 className="logo-title">{props.appName}</h5>
                        </Link>
                        <div className="sidebar-toggle" data-toggle="sidebar" data-active="true" onClick={minisidebar}>
                            <button className="sidebar-toggle-button text-gray-200">
                                {sideMenuCollapsed ? <ChevronRightIcon /> : <ToogleSidebarIcon />}
                            </button>
                        </div>
                    </div>
                    <div className="pt-0 sidebar-body data-scrollbar" data-scroll="1" id="my-scrollbar">
                        <SidebarProfileCard />

                        <div className="sidebar-list navbar-collapse" id="sidebar">
                            <VerticalNav />
                        </div>
                    </div>
                    <div className="sidebar-footer"></div>
                </div>
                <div className="border-top">
                    <ul className="navbar-nav">
                        <li className="nav-item">
                            <button
                                type="button"
                                onClick={() => onLogout(false)}
                                className="nav-link border-0 bg-transparent text-start w-100"
                            >
                                <OverlayTrigger placement="right" overlay={<Tooltip>Sign out</Tooltip>}>
                                    <i className="icon text-gray-200">
                                        <LogoutIcon />
                                    </i>
                                </OverlayTrigger>
                                <span className="item-name">Sign out</span>
                            </button>
                        </li>
                    </ul>
                </div>
            </aside>
        </Fragment>
    )
})

Sidebar.displayName = 'Sidebar'
export default Sidebar
